export default __webpack_public_path__ + "/assets/avatar.jpg";